// TODO: to delete later , during Placement refactoring
export var PlacedPlacementGrouping;
(function (PlacedPlacementGrouping) {
    PlacedPlacementGrouping[PlacedPlacementGrouping["None"] = 0] = "None";
    PlacedPlacementGrouping[PlacedPlacementGrouping["Client"] = 1] = "Client";
    PlacedPlacementGrouping[PlacedPlacementGrouping["Place"] = 2] = "Place";
})(PlacedPlacementGrouping || (PlacedPlacementGrouping = {}));
